var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExperiment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdec7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#c1ea76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9563,
    stopColor: "#a1e66b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ee66a"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 404.328,
    x2: 437.104,
    xlinkHref: "#lg1",
    y1: 441.169,
    y2: 473.248
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0ddfc"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(-.522 .853 -.853 -.522 -217.051 32.755)",
    gradientUnits: "userSpaceOnUse",
    x1: -206.09,
    x2: -19.625,
    xlinkHref: "#lg2",
    y1: -498.411,
    y2: -380.444
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(-.522 .853 -.853 -.522 -217.051 32.755)",
    gradientUnits: "userSpaceOnUse",
    x1: -102.625,
    x2: -256.616,
    xlinkHref: "#lg2",
    y1: -497.938,
    y2: -358.691
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(.972 -.235 .235 .972 -72.269 -58.823)",
    gradientUnits: "userSpaceOnUse",
    x1: 253.227,
    x2: 206.027,
    xlinkHref: "#lg1",
    y1: 280.177,
    y2: 327.376
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.414,
    x2: 175.215,
    xlinkHref: "#lg1",
    y1: 109.747,
    y2: 156.947
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(-.522 .853 -.853 -.522 -217.051 32.755)",
    gradientUnits: "userSpaceOnUse",
    x1: -143.049,
    x2: -129.285,
    xlinkHref: "#lg2",
    y1: -650.952,
    y2: -564.437
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(.522 -.853 -.853 -.522 -467.184 441.971)",
    gradientUnits: "userSpaceOnUse",
    x1: 663.815,
    x2: 676.35,
    xlinkHref: "#lg1",
    y1: -473.111,
    y2: -516.614
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(.972 -.235 .235 .972 -72.269 -58.823)",
    gradientUnits: "userSpaceOnUse",
    x1: 279.387,
    x2: 291.84,
    xlinkHref: "#lg1",
    y1: 273.389,
    y2: 333.58
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(.235 .972 -.972 .235 144.982 487.472)",
    gradientUnits: "userSpaceOnUse",
    x1: -380.374,
    x2: -449.282,
    y1: -89.508,
    y2: 26.723
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ddfc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1831,
    stopColor: "#ecd9f9",
    stopOpacity: 0.183
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3829,
    stopColor: "#deccf0",
    stopOpacity: 0.383
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5905,
    stopColor: "#c9b8e1",
    stopOpacity: 0.591
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8021,
    stopColor: "#aa9bcc",
    stopOpacity: 0.802
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779b3"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.948,
    x2: 153.615,
    y1: 107.777,
    y2: -34.89
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 411.938,
    x2: 381.242,
    xlinkHref: "#lg1",
    y1: 306.325,
    y2: 334.082
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m459.808 456.916c0 29.317-23.64 53.084-52.801 53.084s-52.801-23.766-52.801-53.084c0-29.317 23.64-90.189 52.801-90.189s52.801 60.872 52.801 90.189z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m62.309 39.472c23.755-38.863 74.518-51.111 113.381-27.356l264.426 161.63-86.026 140.737-264.425-161.63c-38.864-23.755-51.111-74.517-27.356-113.381z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.47 48.803 1.144-1.872c18.724-30.632 58.734-40.285 89.366-21.562l265.596 162.345-68.949 112.8-265.595-162.345c-30.632-18.723-40.285-58.734-21.562-89.366z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.243 95.288c-17.805-10.883-38.772-12.162-56.892-5.324 2.177 19.245 12.876 37.322 30.681 48.205l265.596 162.345 26.211-42.881z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.052 136.809-179.878-109.95c-30.638-18.728-70.645-9.064-89.365 21.561l-1.146 1.875c-18.72 30.625-9.077 70.637 21.561 89.365l184.168 112.572c8.43-4.008 15.827-10.426 21.065-18.995 13.159-21.528 8.042-49.095-10.968-64.621.56-.747 1.09-1.529 1.582-2.334 2.676-4.379 4.2-9.134 4.659-13.9 17.41 7.427 38.092 1.161 48.252-15.46z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.405 287.377 71.522-117.01c7.645-12.508 23.982-16.449 36.49-8.804 12.508 7.645 16.449 23.982 8.804 36.49l-71.521 117.011c-7.645 12.508-23.983 16.449-36.49 8.804-12.508-7.646-16.45-23.983-8.805-36.491z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.919 96.385 66.131 40.422c-.01.016-.018.033-.028.049l-.04.065c-6.768 11.072-18.205 17.541-30.233 18.437-6.03.447-12.207-.501-18.02-2.985-1.708-.737-3.388-1.596-5.026-2.598-11.647-7.119-18.211-19.399-18.53-32.102-.194-7.222 1.634-14.571 5.674-21.181.023-.037.05-.07.072-.107z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.198 121.201c-2.563-1.567-5.26-2.741-8.025-3.527-13.83-3.998-29.164 1.525-37.04 14.41-6.063 9.92-6.22 21.797-1.46 31.519 2.646 5.415 6.803 10.16 12.332 13.539 14.634 8.945 33.517 5.054 43.486-8.525.562-.744 1.086-1.526 1.583-2.339 2.671-4.369 4.202-9.128 4.656-13.903 1.183-12.108-4.453-24.402-15.532-31.174z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.87 62.349-82.18-50.233c-38.864-23.755-89.626-11.507-113.381 27.356-23.755 38.863-11.508 89.626 27.356 113.381l82.18 50.233z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m299.731 152.382c7.218 3.079 14.998 3.798 22.358 2.407l-193.375-118.2c-16.928-10.347-39.244-5.376-49.694 11.489-.07.113-.14.227-.21.341l-1.146 1.875c-18.033 29.503-9.737 67.708 18.285 87.212l187.577 114.656c8.374-4.012 15.722-10.403 20.932-18.926 13.159-21.528 8.042-49.095-10.968-64.621.56-.747 1.09-1.529 1.582-2.334 2.676-4.378 4.2-9.132 4.659-13.899z",
    fill: "url(#SVGID_10_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m402.023 265.207-26.202 42.877c6.328 3.868 10.187 10.75 10.187 18.166v5.919c0 11.692 9.478 21.171 21.171 21.171 11.692 0 21.171-9.478 21.171-21.171v-20.018c0-19.165-9.974-36.949-26.327-46.944z",
    fill: "url(#SVGID_11_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExperiment);
export default __webpack_public_path__ + "static/media/icon-experiment.b917e0b3907bb9f3eb654bb5f572f7ca.svg";
export { ForwardRef as ReactComponent };